import React, { useState } from "react";
import { Box, Typography, Chip } from "@mui/material";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import TuneRoundedIcon              from "@mui/icons-material/TuneRounded";
import ReceiptLongRoundedIcon       from "@mui/icons-material/ReceiptLongRounded";
import SmartToyRoundedIcon          from "@mui/icons-material/SmartToyRounded";
import LogsTab       from "./LogsTab";
import ConfigTab     from "./ConfigTab";
import BookingLogsTab from "./BookingLogsTab";
import { AI_OPS_BG } from "./_aiOpsTheme";

const TABS = [
  { label:"Insights Logs",  icon:<ChatBubbleOutlineRoundedIcon /> },
  { label:"Config",         icon:<TuneRoundedIcon /> },
  { label:"Booking Logs",   icon:<ReceiptLongRoundedIcon /> },
];

// Pill tab colours match the AI brand
const TAB_ACTIVE = { bgcolor:"rgba(255,255,255,0.22)", color:"#fff", border:"1px solid rgba(255,255,255,0.35)" };
const TAB_IDLE   = { bgcolor:"transparent", color:"rgba(255,255,255,0.65)", border:"1px solid transparent" };

export default function AiInsightsOps() {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ bgcolor: AI_OPS_BG.page, minHeight:"100%" }}>

      {/* ── Gradient header banner ── */}
      <Box sx={{
        background:"linear-gradient(135deg, #007C84 0%, #016268 55%, #005559 100%)",
        color:"white", px:4, pt:3.5, pb:5,
        boxShadow:"0 8px 32px rgba(79,70,229,0.25)",
      }}>
        <Box sx={{ display:"flex", alignItems:"center", gap:1, mb:1.5 }}>
          <Box sx={{ width:46, height:46, borderRadius:"12px", bgcolor:"rgba(255,255,255,0.15)", border:"1px solid rgba(255,255,255,0.25)", display:"flex", alignItems:"center", justifyContent:"center" }}>
            <SmartToyRoundedIcon sx={{ fontSize:24, color:"#fff" }} />
          </Box>
          <Box sx={{ display:"flex", gap:0.75 }}>
            <Chip size="small" label="AI"  sx={{ bgcolor:"rgba(255,255,255,0.2)", color:"white", fontWeight:800, letterSpacing:0.6, fontSize:10, height:22, border:"1px solid rgba(255,255,255,0.3)" }} />
            <Chip size="small" label="OPS" sx={{ bgcolor:"rgba(255,255,255,0.2)", color:"white", fontWeight:800, letterSpacing:0.6, fontSize:10, height:22, border:"1px solid rgba(255,255,255,0.3)" }} />
          </Box>
        </Box>
        <Typography sx={{ fontSize:26, fontWeight:800, letterSpacing:-0.5, lineHeight:1.1, mb:0.8, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
          AI Ops Console
        </Typography>
        <Typography sx={{ fontSize:13, color:"rgba(255,255,255,0.8)", maxWidth:640, lineHeight:1.6, mb:2.5 }}>
          Read-only telemetry + tunable system config for AI Insights (/ask + /askFromAudio) and AI Booking (/extractBooking + audio).
        </Typography>

        {/* ── Pill tab toggle (inside gradient) ── */}
        <Box sx={{ display:"flex", gap:0.5, bgcolor:"rgba(255,255,255,0.1)", border:"1px solid rgba(255,255,255,0.2)", borderRadius:"14px", p:0.6, width:"fit-content" }}>
          {TABS.map((t, i) => (
            <Box key={i} onClick={() => setTab(i)} sx={{
              display:"flex", alignItems:"center", gap:0.8,
              px:2.2, py:1, borderRadius:"10px", cursor:"pointer",
              ...(tab===i ? TAB_ACTIVE : TAB_IDLE),
              fontWeight: tab===i ? 700 : 500, fontSize:13, transition:"all 0.15s",
              fontFamily:"'Plus Jakarta Sans',sans-serif",
              "&:hover": tab!==i ? { bgcolor:"rgba(255,255,255,0.12)", color:"#fff" } : {},
            }}>
              {React.cloneElement(t.icon, { sx:{ fontSize:15 } })}
              {t.label}
            </Box>
          ))}
        </Box>
      </Box>

      {/* ── Tab content ── */}
      <Box sx={{ px:3, pt:3, pb:3, mt:-1, bgcolor:"white", borderTopLeftRadius:20, borderTopRightRadius:20,
        boxShadow:"0 -6px 24px -8px rgba(79,70,229,0.18)", minHeight:"calc(100vh - 240px)" }}>
        {tab === 0 && <LogsTab />}
        {tab === 1 && <ConfigTab />}
        {tab === 2 && <BookingLogsTab />}
      </Box>
    </Box>
  );
}
